import { Component, OnInit } from '@angular/core';
import { BrokerInitService } from '../shared/BrokerInitService';
import { UrlResp } from '../shared/UrlResp';
import { Router } from '@angular/router';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-broker',
  templateUrl: './broker.component.html',
  styleUrls: ['./broker.component.scss']
})
export class BrokerComponent implements OnInit {
  data: UrlResp;
  constructor(private router: Router,public brokerService: BrokerInitService, private appInsightsService: AppInsightsService) { }

  ngOnInit() {
    console.log('loading broker service');
    this.appInsightsService.logPageView("Broker UI Page View");
    window.scroll(0,0);
    this.brokerService.getBroker().subscribe( res => {
      this.data = res;
      if (this.data) {
          if (this.data.status_code !== '200') {
            // this.error = true;
            // this.message = errorList.get('1');
            // this.loginService.setType('broker');
            
            this.router.navigate(['/' + ((this.router.url.indexOf('ces') == -1) ? this.data.url : 'ces/' + this.data.url)]);
          } else {
            console.log('url ' + this.data.url);
            window.location.href = this.generateCesUrl(window.location.origin + this.data.url, this.router.url);
          }
      }
    });
  }

  generateCesUrl(redirectUrl: string, currentUrl: string){
    if(currentUrl.indexOf('ces') == -1){
      return redirectUrl;
    }else{
      if(redirectUrl.indexOf('ces') == -1){
        var urlArray = redirectUrl.split('/');
        return urlArray.slice(0, 4).join('/') + '/ces/' + urlArray.slice(4).join('/');
      }else{
        return redirectUrl;
      }
    }
  }

}
